/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
export default class PostRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      page: this.store.findRecord('posts/page', params.page_id),
      post: this.store.findRecord('posts/post', params.post_id, {
        include: 'comments,reactions',
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('application').set('currentPageId', model.page.id);
  }
}
